import { takeLatest, call, put, select } from "redux-saga/effects";
import * as types from "src/types/actions";
import { rentalCallApi } from "./helpers";
import { rentalManageURL } from "../env";
// import {
//   AU_VEHICLE_CLASSES,
//   NZ_VEHICLE_CLASSES,
// } from "../../public/static/json/vehicleClasses.json";
import vehicleClasses from "@myjourney-assets/json/vehicleClasses.json";
import getCountryFromURL from "src/utils/getCountryFromUrl";

export function* rentalManageLogin(action) {
  try {
    const country = getCountryFromURL();
    const { response, data } = yield call(
      rentalCallApi,
      () =>
        fetch(`${rentalManageURL}/login`, {
          headers: { "Content-Type": "application/json" },
          mode: "cors",
          method: "POST",
          body: JSON.stringify(action.payload),
        }),
      action.type
    );

    if (response && response.ok) {
      const dateTime = new Date(data.data.originalReturnDate);
      const now = new Date();
      if (dateTime < now) {
        console.log("past date");
        yield put({
          type: types.RENTAL_ERROR_ALERT_OPEN,
          payload: { message: "Your booking is currently not eligible for online changes." },
        });
        yield put({
          type: types.SET_ELIGIBLE_FLAG,
          payload: { eligibleFlag: false },
        });
      } else if (data.data.extension_flag) {
        yield put({
          type: types.RENTAL_ERROR_ALERT_OPEN,
          payload: { message: "You've reached the maximum extension allowed for this booking." },
        });
      } else if (
        !data.data.locationEligible ||
        (data.data.vehicle &&
          ((country === "AU" && !AU_VEHICLE_CLASSES.includes(data.data.vehicle.VehicleClass)) ||
            (country === "NZ" && !NZ_VEHICLE_CLASSES.includes(data.data.vehicle.VehicleClass)))) ||
        !data.data.vehicle.VehicleClass
      ) {
        if (!data.data.locationEligible) {
          console.log("location not eligible");
        } else {
          console.log("vehicle class not eligible");
        }
        yield put({
          type: types.RENTAL_ERROR_ALERT_OPEN,
          payload: { message: "Your booking isn't eligible for online changes." },
        });
        yield put({
          type: types.SET_ELIGIBLE_FLAG,
          payload: { eligibleFlag: false },
        });
      } else {
        yield put({
          type: types.CREATE_TOAST,
          payload: { type: "success", message: "Login success" },
        });
        yield put({
          type: types.SET_ELIGIBLE_FLAG,
          payload: { eligibleFlag: true },
        });
      }
    } else {
      yield put({
        type: types.CREATE_TOAST,
        payload: { type: "error", message: "Login failed, please check your vehicle details." },
      });
      yield put({
        type: types.RENTAL_ERROR_ALERT_OPEN,
        payload: { message: "Sorry, we couldn't find your booking." },
      });
      yield put({
        type: types.SET_ELIGIBLE_FLAG,
        payload: { eligibleFlag: false },
      });
    }
  } catch (error) {
    yield put({ type: types.RENTAL_LOGIN_FAILURE, error });
    yield put({
      type: types.CREATE_TOAST,
      payload: { type: "error", message: "Login failed" },
    });
    yield put({
      type: types.RENTAL_ERROR_ALERT_OPEN,
      payload: { message: "Your booking is currently not eligible for online changes." },
    });
    yield put({
      type: types.SET_ELIGIBLE_FLAG,
      payload: { eligibleFlag: false },
    });
  }
}

export function* updateReturnDate(action) {
  try {
    const authorization = yield select((state) => state.rental.token);

    const { response } = yield call(
      rentalCallApi,
      () =>
        fetch(`${rentalManageURL}/rental/${action.payload.ra_number}`, {
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${authorization}` },
          mode: "cors",
          method: "POST",
          body: JSON.stringify(action.payload),
        }),
      action.type
    );

    if (response && response.ok) {
      yield put({
        type: types.CREATE_TOAST,
        payload: { type: "success", message: "Return date updated successfully" },
      });
    } else {
      yield put({
        type: types.RENTAL_ERROR_ALERT_OPEN,
        payload: { message: "Your booking is currently not eligible for online changes." },
      });
    }
  } catch (error) {
    yield put({ type: types.UPDATE_RETURN_DATE_FAILURE, error });
    yield put({
      type: types.RENTAL_ERROR_ALERT_OPEN,
      payload: { message: "Your booking is currently not eligible for online changes." },
    });
  }
}

export function* watchRentalManageRequest() {
  yield takeLatest(types.RENTAL_LOGIN, rentalManageLogin);
  yield takeLatest(types.UPDATE_RETURN_DATE, updateReturnDate);
}
